import { forwardRef, MouseEventHandler, Ref } from "react";
import styled from 'styled-components'

/*

consider 

adding svg coloring:     svg {
      font-size: 2rem;
      color: ${(props) => props.color};
    }
    // this should better handle the active prop

    the attrs block: `.attrs({type: 'button'})`
    is intended to set the button type away from submit (which seems to be the default, when inside a form, or a subcomponent of a form)
*/


const Wrapper = styled.button.attrs({type: 'button'})<{ 
  $w?: string, $h?: string, 
  $p?: string, $pt?: string, $pl?: string,
  $m?: string, $mt?: string, $ml?: string, 
  $bgColor?: string, 
  $bgaColor?: string, 
  $bRad?: string, 
  $color?: string, 
  $bColor?: string, 
  $bWidth?: string, 
  $bStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',
  $label?: string
  $active?: boolean, 
  $disabled?: boolean, 
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined, 
  onMouseDown?: MouseEventHandler<HTMLButtonElement> | undefined, 
}>`
  
  ${props => props.$w ? 'width: ' + props.$w + '; ' : ''}
  ${props => props.$h ? 'height: ' + props.$h + '; ' : ''}
  ${props => props.$p ? 'padding: ' + props.$p + '; ' : ''}
  ${props => props.$pt ? 'padding-top: ' + props.$pt + '; ' : ''}
  ${props => props.$pl ? 'padding-left: ' + props.$pl + '; ' : ''}
  ${props => props.$m ? 'margin: ' + props.$m + '; ' : ''}
  ${props => props.$mt ? 'margin-top: ' + props.$mt + '; ' : ''}
  ${props => props.$ml ? 'margin-left: ' + props.$ml + '; ' : ''}
  ${props => props.$bgColor ? 'background-color: ' + props.$bgColor + '; ' : ''}
  ${props => props.$bRad ? 'border-radius: ' + props.$bRad + '; ' : ''}
  ${props => props.$bColor ? 'border-color: ' + props.$bColor + '; ' : ''}
  ${props => props.$bWidth ? 'border-width: ' + props.$bWidth + '; ' : ''}
  ${props => props.$bStyle ? 'border-style: ' + props.$bStyle + '; ' : ''}
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  appearance: 'none';
  -webkit-box-align: 'center';
  align-items: 'center';
  -webkit-box-pack: 'center';
  justify-content: 'center';
  user-select: 'none';
  position: 'relative';
  white-space-collapse: 'collapse';
  text-wrap: 'nowrap';
  vertical-align: 'middle';
  &:hover {
    ${props => props.$bgaColor ? 'background-color: ' + props.$bgaColor + '; ' : ''}
  }

`

interface IconButtonProps<T extends HTMLButtonElement>
  extends React.HTMLProps<T> {
  active?: boolean, disabled?: boolean,
  icon: JSX.Element,
  label?: string,  // find out/remember what these were for
  fontSize?: string,  // find out/remember what these were for
  w: string,
  h: string,
  p: string, pt?: string, pl?: string, 
  m: string, mt?: string, ml?: string, 
  bgColor?: string
  bgaColor?: string
  bColor?: string
  bRad?: string
  bWidth?: string,
  bStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',

  onClick?: MouseEventHandler<HTMLButtonElement> | undefined, 
  onMouseDown?: MouseEventHandler<HTMLButtonElement> | undefined, 
}

export const IconButton = forwardRef(<T extends HTMLButtonElement>(props: IconButtonProps<T>, ref:Ref<HTMLButtonElement>) => {
  
  return <Wrapper {...ref} $active={props.active} $disabled={props.disabled} 
            $w={props.w} $h={props.h} $p={props.p} $pt={props.pt} $pl={props.pl} $m={props.m} $mt={props.mt} $ml={props.ml} 
            onClick={props.onClick} tabIndex={props.tabIndex} onMouseDown={props.onMouseDown} 
            $bgColor={props.bgColor} $color={props.color} $bColor={props.bColor} $bWidth={props.bWidth} $bStyle={props.bStyle} $bRad={props.bRad}
    >
      {props.icon}
   
  </Wrapper>
});